import React, { ChangeEventHandler } from 'react';
import classNames from 'classnames';
import { RCCheckableLabel, CheckableLabelProps } from './RCCheckableLabel';
import CheckIcon from '../../../../design-system/icons/core/check.svg?component';
import { RCIcon } from '../../RCIcon';

interface IRCSwitch extends CheckableLabelProps {
  name: string;
  id: string;
  checked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

// DO NOT USE THIS
// Component is WIP and not yet ready for consumption

export function RCSwitch(props: IRCSwitch) {
  return (
    <span className={classNames(
      'rc-switch',
      { 'rc-switch--disabled': props.disabled },
    )}>
      <input
        className="rc-switch__input"
        type="checkbox"
        name={props.name}
        id={props.id}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <span className="rc-switch__box">
        <RCIcon svgComponent={CheckIcon} />
      </span>
      <RCCheckableLabel
        for={props.id}
        label={props.label}
        sublabel={props.sublabel}
      />
    </span>
  );
}
